import { Outlet } from 'react-router';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Header from './Header';

const AppLayout = () => (
  <Stack sx={{ height: '100%' }}>
    <Box sx={{ minHeight: '40px' }}>
      <Header />
    </Box>
    <Box sx={{ flex: 1, overflow: 'auto' }}>
      <Outlet />
    </Box>
  </Stack>
);

export default AppLayout;
